import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const sliderData = [
    {
        id: 1,
        question: "ServiceNow Consulting Services",
        answer: "At Mobikode, we tailor ServiceNow to fit your business needs and create a clear, practical roadmap that supports your digital transformation in a simple, effective way."
    },
    {
        id: 2,
        question: "ServiceNow Implementation Services",
        answer: "At Mobikode, we tailor ServiceNow to fit your business needs and create a clear, practical roadmap that supports your digital transformation in a simple, effective way."
    },
    {
        id: 3,
        question: "ServiceNow Migration Services",
        answer: "At Mobikode, we tailor ServiceNow to fit your business needs and create a clear, practical roadmap that supports your digital transformation in a simple, effective way."
    },
    {
        id: 4,
        question: "ServiceNow Managed Services",
        answer: "At Mobikode, we tailor ServiceNow to fit your business needs and create a clear, practical roadmap that supports your digital transformation in a simple, effective way."
    }
];

const ServiceNowSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true, // <-- Isse slider infinite loop me chalega
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
        breakpoints: {
            "(min-width: 640px)": {
                slides: { perView: 1.5, spacing: 20 },
            },
            "(min-width: 768px)": {
                slides: { perView: 2.2, spacing: 20 },
            },
            "(min-width: 1024px)": {
                slides: { perView: 3, spacing: 24 },
            },
        },
        slides: { perView: 1.1, spacing: 16 },
    });

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] overflow-hidden bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="flex justify-start mb-[24px] md:mb-[60px]"
                >
                    <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        ServiceNow Consulting
                    </h2>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    variants={fadeUpVariant}
                    className="relative"
                >
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden">
                        {sliderData.map((slide) => (
                            <div className="keen-slider__slide" key={slide.id}>
                                <div className="group relative flex flex-col p-[24px] sm:p-[30px] md:p-[40px] bg-[#F0F0F0] md:hover:bg-[#01386A] transition-colors duration-500 h-[320px] sm:h-[360px] md:h-[400px] overflow-hidden cursor-pointer rounded-sm">

                                    <h3 className="font-sora text-[16px] md:text-[20px] font-[600] text-[#01386A] md:group-hover:text-white transition-colors duration-300 mb-[16px] md:mb-[20px]">
                                        {slide.question}
                                    </h3>

                                    <div className="mt-auto w-full">
                                        <div className="grid grid-rows-[1fr] md:grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:md:grid-rows-[1fr]">
                                            <div className="overflow-hidden">
                                                <p className="font-graphik text-[14px] md:text-[16px] font-[500] text-[#49577A] md:text-white leading-[1.5] md:leading-[1.6] opacity-100 md:opacity-0 group-hover:md:opacity-100 transition-opacity duration-500 delay-100 pb-[10px]">
                                                    {slide.answer}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="absolute bottom-[24px] sm:bottom-[30px] md:bottom-[40px] left-[24px] sm:left-[30px] md:left-[40px] transition-opacity duration-300 md:group-hover:opacity-0 pointer-events-none flex items-center">
                                        <span className="font-graphik text-[14px] md:text-[16px] font-[500] text-[#01386A] border-b border-[#01386A] pb-[2px]">
                                            Read More
                                        </span>
                                        <span className="text-[#ED6800] ml-2 font-bold text-[16px]">&gt;</span>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-[16px] mt-[24px] md:mt-[40px]">
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] transition-colors hover:bg-[#ED6800] hover:text-white"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] transition-colors hover:bg-[#ED6800] hover:text-white"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </motion.div>

            </div>
        </section>
    );
};

export default ServiceNowSlider;